import { createClient, SupabaseClient } from '@supabase/supabase-js'

/**
 * PUNTO ÚNICO DE CONEXIÓN CON SUPABASE
 * ------------------------------------------------------------------
 * Este entorno no dispone de variables de entorno, por lo que la URL y la
 * clave anónima (publishable) se definen como constantes. Es seguro: la
 * anon key está pensada para el cliente y TODAS las tablas tienen Row Level
 * Security activo. Nunca debe aparecer aquí la service_role key.
 */

export const SUPABASE_URL = 'https://hjuwvuqvwzzqewzmudag.supabase.co'

export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqdXd2dXF2d3p6cWV3em11ZGFnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU2Njk1MDQsImV4cCI6MjEwMTI0NTUwNH0.xIo2Ijy-xZug_1sxF4UCVRmSQBp8qRWFNdBAmgGuq0g'

export const SUPABASE_ENABLED = true

export const supabase: SupabaseClient = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
)

/** Buckets de Storage ya creados y con políticas activas. */
export const BUCKETS = {
  logos: 'organization-logos',
  favicons: 'organization-favicons',
  landingAssets: 'landing-assets',
  avatars: 'avatars',
  leadFiles: 'lead-files',
} as const

/** Lanza el error de Supabase con un mensaje legible para la interfaz. */
export function assertOk<T>(result: {
  data: T
  error: { message: string } | null
}): T {
  if (result.error) throw new Error(result.error.message)
  return result.data
}
